import {Component} from "@angular/core";
import {ModalService} from "../../../shared/modal/modal.service";

@Component({
  templateUrl: './talent.pool.scores.modal.template.html'
})

export class TalentPoolScoresModalComponent extends ModalService implements IModalService {
}
